import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Modal } from 'react-bootstrap';

class ModalInputImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 1,
      name: '',
      image: '',
      value: '',
    };
  }
  handleChange (name, event) {
    var imagedata = document.querySelector('input[type="file"]').files[0];

    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    this.props.changeStateByComponent(imagedata);
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <input type="text" type="file" name="image" className="form-control" placeholder="Arquivo" value={self.state.image} onChange={self.handleChange.bind(self, 'image')} />
</div>
    );
  }
}

export default ModalInputImage;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/ModalInputImage.js